import axios from 'CanExConfig/axios'

export const captureUTM = async params => {
  const response = await axios(`/utms${params}`, {
    method: 'GET',
  })

  return response
}
